import { Box, LinearProgress, Typography, alpha, useTheme } from '@mui/material'
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts'
import _ from 'lodash'
import { useTasksInOrg } from '~/tasks/hooks/use-org-tasks'
import { useTaskVelocityData } from './use-task-velocity-data'
import { TaskVelocityTooltip } from './task-velocity-tooltip'

export const TaskVelocityChart = () => {
  const theme = useTheme()
  const { tasks } = useTasksInOrg()
  const data = useTaskVelocityData(tasks)

  const monthTicks = data.filter(d => d.monthLabel).map(d => d.weekLabel)
  const cursorColor = theme.palette.mode === 'dark'
    ? alpha('#ffffff', 0.06)
    : alpha('#000000', 0.04)

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontWeight: 600,
          fontSize: '0.65rem',
          letterSpacing: '0.05em',
          mb: 0.25,
          flexShrink: 0
        }}
      >
        TASK VELOCITY
      </Typography>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 4, right: 8, bottom: 4, left: 4 }}
            maxBarSize={20}
            barCategoryGap="25%"
          >
            <CartesianGrid
              strokeDasharray="3 3"
              stroke={theme.palette.divider}
              vertical={false}
            />
            <XAxis
              dataKey="weekLabel"
              ticks={monthTicks}
              tickFormatter={(wl) => data.find(d => d.weekLabel === wl)?.monthLabel ?? wl}
              tick={{ fontSize: 8, fill: theme.palette.text.secondary }}
              tickLine={false}
              axisLine={{ stroke: theme.palette.divider }}
            />
            <Tooltip
              content={<TaskVelocityTooltip />}
              cursor={{ fill: cursorColor }}
              wrapperStyle={{ zIndex: 10, transition: 'none' }}
              animationDuration={0}
            />
            {/* Completed tasks — stacked top, success main */}
            <Bar
              dataKey="completedTasks"
              stackId="tasks"
              fill={theme.palette.success.main}
              radius={[0, 0, 0, 0]}
            />
            {/* Remaining tasks — stacked bottom, lighter primary */}
            <Bar
              dataKey="remaining"
              stackId="tasks"
              fill={theme.palette.primary.light}
              radius={[2, 2, 0, 0]}
              opacity={0.45}
            />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  )
}
